/* TUFY custom: toggle reveal-fix only when the widget's "block animations" is ON */
(function () {
  var FLAG = 'sa-stop-anim';

  // הסרת הדגל כברירת מחדל
  document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.remove(FLAG);
  });

  // עוזר: קובע או מסיר את הדגל
  function setFlag(on) {
    document.body.classList.toggle(FLAG, !!on);
  }

  // נסיון לזהות כפתור "חסימת אנימציות" בווידג׳טים נפוצים
  function findToggleButtons(root) {
    var candidates = [];
    root = root || document;

    // לפי טקסט או aria-label בעברית ובאנגלית
    var selectors = [
      'button[aria-label*="חסימת אנימציות"]',
      'button[aria-label*="עצירת אנימציות"]',
      'button[aria-label*="Stop animations" i]',
      'button[aria-label*="Reduce motion" i]',
      'button[data-action*="stop-animations" i]',
      'button[data-action*="reduce-motion" i]',
      '.sa-toolbar button',           // SenseApps נפוץ
      '.accessibility-widget button'  // כללי
    ];

    candidates = selectors
      .map(function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); })
      .reduce(function (acc, arr) { return acc.concat(arr); }, []);

    // סינון לפי טקסט בכפתור, אם יש
    candidates = candidates.filter(function (btn) {
      var t = (btn.textContent || '').trim().toLowerCase();
      return /חסימת אנימציות|עצירת אנימציות|stop animations|reduce motion/.test(t) || btn.hasAttribute('aria-label') || btn.hasAttribute('data-action');
    });

    return candidates;
  }

  // מאזין לכפתורים שמצאנו
  function wireButton(btn) {
    if (btn.__tufyWired) return;
    btn.__tufyWired = true;

    // אם לכפתור יש aria-pressed, נשתמש בו כאמת מידה
    function refreshFromAria() {
      var pressed = btn.getAttribute('aria-pressed');
      if (pressed === 'true') setFlag(true);
      else if (pressed === 'false') setFlag(false);
    }

    btn.addEventListener('click', function () {
      // נסה קודם לקרוא מצב נוכחי
      refreshFromAria();

      // אם אין aria-pressed, נבדוק מחלקה פעילה בכפתור אחרי טיקט קצר
      setTimeout(function () {
        if (btn.getAttribute('aria-pressed') == null) {
          var active = /active|on|selected|toggled/i.test(btn.className);
          setFlag(active);
        }
      }, 50);
    });

    // רענון ראשון
    refreshFromAria();
  }

  // חיבור ראשוני
  findToggleButtons(document).forEach(wireButton);

  // מעקב אחרי הזרקות של הווידג׳ט עד שמוצאים כפתור
  var obs = new MutationObserver(function (muts) {
    findToggleButtons(document).forEach(wireButton);
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // כלי עזר לבדיקה ידנית מהקונסול
  window.TUFY_setAnimBlock = setFlag;
})();
